<script>
import vSelect from 'vue-select'
import Vue from "vue";
import axios from "axios";
import { debounce } from "lodash";

Vue.component('v-select', vSelect)

export default {
    name: "SelectClient",
    props: {
        value: { // v-model dans Vue 2 = prop "value"
            type: String,
            default: null
        }
    },
    data() {
        return {
            list_BL: []
        };
    },
    methods: {
        fetch(recherche) {
            const formmulaire = new FormData();
            formmulaire.append("recherche", recherche);

            axios.post(this.BASE_URL + "/dossier/fetch", formmulaire)
                .then((response) => {
                    this.list_BL = response.data;
                })
                .catch((err) => console.error(err));
        },

        onSearch: debounce(function (query) {
            this.fetch(query);
        }, 400),
    },
    mounted() {
        this.fetch('');
    }
}
</script>

<template>
    <div>
        <v-select
            id="nom_poste_depense"
            :options="list_BL"
            :reduce="(m) => m.ouverture_bl_numero"
            label="ouverture_bl_numero"
            v-model="value"
            placeholder="Choisissez un BL"
            @search="onSearch"
            @input="$emit('input', $event)"
            style="width: 350px"
        />
    </div>
</template>
